import * as $ from "jquery";
import { setCookie } from "../../js/utils";

class cookieconsent {

    init = () => {
        // Get the modal
        let $modalElement = $(".cookie-banner-modal");

        // Get the button that opens the modal
        let modalShowButton = $(".cookie-banner-modal__show-btn");

        // Get the close icon that closes the modal
        let modalCloseButton = $(".cookie-banner-modal__close");

        // Get the cancel button that close the modal
        let modalCancelButton = $('.cookie-banner-modal__cancel-btn');

        // Get trageting cookies toggle
        let targetingCookie = $('.cookie-banner-modal__targeting-cookies');

        // Get cookie preferences update button
        let cookieUpdateButton = $(".cookie-banner-modal__update-btn");

        // Get cookie accept all button
        let cookieAcceptAllButton = $('.cookie__accept-all-btn');

        // Get cookie banner
        let cookieBannerElement = $('.cookie-banner');

        // make the modal toggle button active by default
        targetingCookie.prop('checked', true);

        // When the user clicks the button, open the modal 
        modalShowButton.click(function (event) {
            event.preventDefault();
            $('body').addClass('body-overflow-hidden');
            $('.cookie-banner-modal').addClass('modal-active');
        });

        // When the user clicks on (x), close the modal
        modalCloseButton.click(function () {
            $('body').removeClass('body-overflow-hidden')
            $('.cookie-banner-modal').removeClass('modal-active');

        });

        // When the user clicks on cancel button, close the modal
        modalCancelButton.click(function () {
            $('body').removeClass('body-overflow-hidden')
            $('.cookie-banner-modal').removeClass('modal-active');

        });

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function (event) {
            if (event.target === $modalElement.get(0)) {
                $('body').removeClass('body-overflow-hidden');
                $('.cookie-banner-modal').removeClass('modal-active');
            }
        }

        // Function to close the cookie banner popup on outside click
        $(document).on('click',(event: JQuery.ClickEvent<Document, MouseEvent>) =>  {
            if (!$(event.target).closest('.cookie-banner').length && !$(event.target).closest('.cookie-banner-modal').length && !$(event.target).closest('.resero-modal').length) {
                cookieBannerElement.hide();
            }
          });

        // cookie update button click function
        cookieUpdateButton.on('click', function () {
            setCookie('CookieConsentAccepted', 'true', 365);
            $('body').removeClass('body-overflow-hidden')
            $('.cookie-banner-modal').removeClass('modal-active');
            cookieBannerElement.hide();
            if (targetingCookie.is(':checked')) {
                $.ajax({
                    url: "/api/cookieConsent/set",
                    data: { SelectedValue: 200 },
                    method: "POST",
                    success: function (data) {
                    },
                    error: function () {
                    }
                });
            }
            else {
                $.ajax({
                    url: "/api/cookieConsent/set",
                    data: { SelectedValue: 0 },
                    method: "POST",
                    success: function (data) {
                    },
                    error: function () {
                    }
                });
            }
        });

        // cookie accept all button click
        cookieAcceptAllButton.on('click', function () {
            setCookie('CookieConsentAccepted', 'true', 365);
            cookieBannerElement.hide();
            $.ajax({
                url: "/api/cookieConsent/set",
                data: { SelectedValue: 1000 },
                method: "POST",
                success: function (data) {
                },
                error: function () {
                }
            });
        })
    }
}
const CookieConsentInstance = new cookieconsent();
CookieConsentInstance.init();

export { cookieconsent, CookieConsentInstance };

